import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CentralizedControl = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Centralized Home Control</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter">
              Manage Multiple Systems <br />
              <span className="text-[#91756A]">Conveniently</span> from Anywhere.
            </h3>
            <p className="text-slate-500 text-lg leading-relaxed mb-12">
              One of the key advantages of smart home technology is the ability to manage multiple systems from a 
              single interface. Through smartphone apps or smart control panels, homeowners can control lighting, 
              climate, security, and other systems conveniently from anywhere.
            </p>
            
            <div className="bg-slate-50 p-8 border-l-4 border-[#91756A] italic mb-12">
              <p className="text-xl text-slate-600">
                "This centralized approach simplifies home management while improving energy efficiency and security."
              </p>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4, duration: 0.6 }}
              className="flex items-start gap-6 p-6 bg-slate-50 border border-slate-100"
            >
              <div className="w-12 h-12 bg-[#4D4C4A] flex items-center justify-center shrink-0">
                <Icon name="Wind" size={20} className="text-white" />
              </div>
              <div>
                <h4 className="text-lg font-bold text-[#4D4C4A] italic uppercase tracking-tight mb-2">Automated Curtains and Blinds</h4>
                <p className="text-slate-500 text-sm leading-relaxed">
                  Smart curtain and blind systems allow homeowners to adjust natural lighting and privacy automatically or 
                  remotely. These systems can be programmed to operate according to schedules or environmental 
                  conditions.
                </p>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="relative aspect-square"
          >
            <div className="absolute inset-0 overflow-hidden">
              <Image 
                src="/assets/images/Smart-home-page/Smart-Home-1080-3.jpg" 
                alt="Centralized Control" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-[#4D4C4A]/30"></div>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <span className="block text-4xl md:text-6xl font-bold text-white opacity-90 italic uppercase">SMART</span>
              <span className="block text-xl md:text-2xl font-bold text-white opacity-80 italic uppercase tracking-widest">Interface</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CentralizedControl;